import React, { createContext, useContext } from "react";
import { EnumStatisticStatusGroup } from "../../../../server/routes/statistic/types";
import { StatusGroupProviderFC } from "./types";

const statusGroupContext = createContext<{
  statusGroup: EnumStatisticStatusGroup | null;
  additionalChart?: (EnumStatisticStatusGroup | "orders_received")[];
  chartTitle: string;
  gridTitle: string;
}>({ statusGroup: null, chartTitle: "", gridTitle: "" });

export const useStatusGroup = () => {
  const { statusGroup, chartTitle, gridTitle, additionalChart } =
    useContext(statusGroupContext);
  if (!statusGroup) {
    throw new Error("Не верный вызов провайдера StatusGroupProvider");
  }
  return { statusGroup, chartTitle, gridTitle, additionalChart };
};

const StatusGroupProvider: StatusGroupProviderFC = ({
  statusGroup,
  chartTitle,
  additionalChart,
  gridTitle,
  children,
}) => {
  if (!statusGroup) {
    console.error("Не верный вызов провайдера StatusGroupProvider");
    return <></>;
  }
  return (
    <statusGroupContext.Provider
      value={{ statusGroup, chartTitle, gridTitle, additionalChart }}
    >
      {children}
    </statusGroupContext.Provider>
  );
};

export default StatusGroupProvider;
